<template>
  <v-layout rows wrap
    style=""
    id="contact_form"
    :class="!$vuetify.breakpoint.mdAndUp && hasObject ? 'pa-2' : ''"
    :style="(!$vuetify.breakpoint.mdAndUp && hasObject ? 'margin-top:48px !important;' : '') + 'width: 100%;color: gray;background: white;'"
  >
    <template v-if="!bookingSent">
      <v-flex v-if="!sidebar" xs12 pa-1>
        <a name="booking_form"></a>
        <h1>{{ hasObject ? $i18n.t('broneeri_kohe') : $i18n.t('saada') }}</h1>
      </v-flex>
      <v-flex xs12 v-if="hasObject && !computedMobile">
        <object-list-info
          v-if="!loadingObjectInfo"
          :object="object"
          :booking-now="true"
          :hide-price="true"
        />
        <div
          v-else
          :style="'height: ' + ($vuetify.breakpoint.mdAndUp ? 188 : 420) + 'px;text-align:center;'"
        >
          <my-loader :spacing="50" />
        </div>
      </v-flex>
      <template v-else-if="hasObject && !sidebar">
        <v-flex xs9>
          <h3>{{ object.objectName }}, {{ object.address }}</h3>
        </v-flex>
        <v-flex xs3>
          <img
            v-if="object && object.objectImages && object.objectImages[0]"
            :src="'https://s3.eu-central-1.amazonaws.com/img.costasolrent.com/objectImages/preview/' + object.objectImages[0].image"
            class="costa-border"
            width="100%"
          >
        </v-flex>
        <v-flex xs9>
        </v-flex>
        <v-flex xs3 style="text-align: center;">
          ID: {{ object.csrId }}
        </v-flex>
      </template>
      <template v-if="!sidebar">

        <!-- NAME -->

        <v-flex
          :xs12="computedMobile"
          :md3="!computedMobile"
          pa-1
        >
          <label>{{ $i18n.t('nimi') }} *</label>
        </v-flex>

        <!-- CUSTOMER NAME -->

        <v-flex
          :xs12="computedMobile"
          :md9="!computedMobile"
          pa-1
        >
          <input v-model="bookingData.customerName" type="text" name="name" style="color: rgb(128, 128, 128);"
                 :class="'full-input ' + (computedMobile ? 'mobile-field' : '')"
          >
        </v-flex>

        <!-- E-MAIL -->

        <v-flex
          :xs12="computedMobile"
          :md3="!computedMobile"
          pa-1>
          <label>{{ $i18n.t('e-mail') }} *</label>
        </v-flex>
        <v-flex
          :xs12="computedMobile"
          :md9="!computedMobile"
          pa-1>
          <input v-model="bookingData.customerEmail" type="text" name="e-mail" style="color: rgb(128, 128, 128);"
            :class="'full-input ' + (computedMobile ? 'mobile-field' : '')"
          >
        </v-flex>

        <!-- PHONE -->

        <v-flex
          :xs12="computedMobile"
          :md3="!computedMobile"
          pa-1>
          <label>{{ $i18n.t('telefon') }} *</label>
        </v-flex>

        <v-flex
          :xs3="computedMobile"
          :md2="!computedMobile"
          pa-1
        >
          <select
            v-model="selectedCountryCallingCode"
            type="text"
            name="booking_extras"
            :class="'full-input ' + (computedMobile ? 'mobile-field' : '')"
          >
            <option
              v-for="countryCallingCode in Object.keys(countryCallingCodes)"
              :key="countryCallingCode"
              style="color: gray"
            >
              +{{ countryCallingCode }}
            </option>
          </select>
          {{  }}
        </v-flex>

        <v-flex
          :xs9="computedMobile"
          :md7="!computedMobile"
          pa-1
        >
          <input
            v-model="bookingData.customerPhone"
            type="text"
            name="phone"
            style="color: rgb(128, 128, 128);"
            :class="'full-input ' + (computedMobile ? 'mobile-field' : '')"
          >
        </v-flex>
      </template>

      <!-- VISITORS -->

      <v-flex
        :xs12="computedMobile"
        :md3="!computedMobile"
        :pa-1="!sidebar"
        :py-1="sidebar"
      >
        <label>{{ $i18n.t('inimeste_arv') }} {{ sidebar ? '' : '*' }}</label>
      </v-flex>
      <v-flex
        :xs12="computedMobile"
        :md9="!computedMobile"
        :pa-1="!sidebar"
        :py-1="sidebar"
      >
        <template>
          <div style="width: 100%; position: relative; ">
            <div @click.stop="personSelectOpened = !personSelectOpened" style="width: 100%; overflow: auto; position: absolute; height: 35px;z-index: 1;opacity: 0;">
            </div>
            <select
              type="text"
              name="booking_extras"
              :class="'full-input ' + (computedMobile ? 'mobile-field' : '')"
            >
              <option style="color: gray" value="-">
                {{ selectedPersonsText }}
              </option>
            </select>
          </div>
        </template>

        <!-- VISITORS SELECT POPUP -->

        <div v-if="personSelectOpened"
          :class="(sidebar ? 'popup-select-container-sidebar' : 'popup-select-container') + ' elevation-5 '"
        >
          <v-layout
            wrap align-center
            class="my-0 mt-0 mb-2"
            style="border-bottom: 1px solid #ddd; padding-bottom: 5px; margin-bottom: 5px;"
          >
            <v-flex xs1 text-xs-center />
            <v-flex
              :xs10="!sidebar"
              :xs9="sidebar"
              text-xs-center
            >
              <b>{{ $i18n.t('inimeste_arv') }}</b>
            </v-flex>
            <v-flex
              :xs1="!sidebar"
              :xs2="sidebar"
              text-xs-right
            >
              <v-btn
               fab flat dark small
               class="form-close"
               @click="personSelectOpened = false"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout
            v-for="(personType, pti) in personTypes"
            :key="pti"
            wrap align-center
          >
            <v-flex xs8>{{ $i18n.t(personType + '_count') }}</v-flex>

            <v-flex xs4 text-xs-center>
              <v-layout wrap align-center>
                <v-flex xs4
                  text-xs-right
                >
                  <v-btn
                   fab flat dark small outline
                   class="plus-minus-btn sidebar-minus"
                   @click="removePerson(personType)"
                  >
                    <v-icon small>fa-minus</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs4
                  text-xs-center
                >{{ bookingData[personType] }}</v-flex>
                <v-flex xs4 text-xs-left>
                  <v-btn
                   fab flat dark x-small outline
                   class="plus-minus-btn sidebar-plus"
                   @click="addPerson(personType)"
                  >
                    <v-icon small>fa-plus</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <!-- // VISITORS SELECT POPUP -->

      <!-- BOOKING -->

      <v-flex
        v-if="!sidebar"
        :xs12="computedMobile"
        :md3="!computedMobile"
        pa-1
      >
        <label>{{ $i18n.t('broneering') }} *</label>
      </v-flex>
      <v-flex
        :xs12="computedMobile"
        :md4="!computedMobile"
        :pa-1="!sidebar"
        :py-2="sidebar"
      >
        <v-layout>
          <v-flex
            :xs8="!sidebar"
            :xs12="sidebar"
            :pr-1="!sidebar"
          >
            <div  style="float:left;width:100%;">

              <!-- START DATE -->

              <input v-model="searchFilters.dateStart"
               :class="'filter-calendar hasDatepicker full-input ' + (computedMobile ? 'mobile-date' : '')"
               type="text"
                autocomplete="off"
                name="arrival" id="arrival" value=""
                :placeholder="$t('saabumise_kuupäev')"
                style="margin: 0;"
                @focus="dateStartFocus($event)"
              >
              <calendar-date-picker
                v-if="showBookingPickerFor === 'dateStart'"
                v-model="searchFilters.dateStart"
                fieldName="dateStart"
                :left="calendarLeftPosition"
                :mobile-padding="calendarMobilePadding"
                @update="updatePickerDate"
              />
            </div>
          </v-flex>
          <v-flex v-if="!sidebar" xs4>

            <!-- CHECK IN TIME -->

            <select v-model="bookingData.checkInTime" type="text" name="checkin_time" id="checkin_time"
                    :class="'full-input ' + (computedMobile ? 'mobile-field' : '')"
            >
              <option
                v-for="(c, i) in checkInTimes"
                :key="i"
                :value="c"
              >
                {{ c }}
              </option>
            </select>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        v-if="!sidebar"
        :xs12="computedMobile"
        :md1="!computedMobile"
        :pa-1="!sidebar"
      >
        <div class="full-input" style="text-align: center;">-</div>
      </v-flex>
      <v-flex
        :xs12="computedMobile"
        :md4="!computedMobile"
        :pa-1="!sidebar"
        :py-2="sidebar"
      >
        <v-layout>
          <v-flex
            :xs8="!sidebar"
            :xs12="sidebar"
            :pr-1="!sidebar"
          >
            <div  style="float:left;width:100%;">

              <!-- END DATE -->

              <input
                v-model="searchFilters.dateEnd"
                autocomplete="off"
                :class="'contact_input_half filter-calendar hasDatepicker full-input ' + (computedMobile ? 'mobile-date' : '')"
                type="text" name="leaving" id="leaving" value=""
                :placeholder="$t('lahkumise_kuupäev')"
                style="margin: 0;"
                @focus="dateEndFocus($event)"
              >
              <calendar-date-picker
                v-if="showBookingPickerFor === 'dateEnd'"
                v-model="searchFilters.dateEnd"
                :starting-from="searchFilters.dateStart"
                fieldName="dateEnd"
                :mobile-padding="calendarMobilePadding"
                :left="calendarLeftPosition"
                @update="updatePickerDate"
              />
            </div>
          </v-flex>
          <v-flex v-if="!sidebar" xs4>

            <!-- CHECK OUT TIME -->

            <select v-model="bookingData.checkOutTime" type="text" name="checkout_time" id="checkout_time"
                    :class="'full-input ' + (computedMobile ? 'mobile-field' : '')"
            >
              <option
                v-for="(c, i) in checkOutTimes"
                :key="i"
                :value="c"
              >
                {{ c }}
              </option>
            </select>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- ARRIVAL TIME -->

      <template v-if="!sidebar">
        <template v-if="!sidebar && sidebar">
          <v-flex
            :xs12="computedMobile"
            :md3="!computedMobile"
            :pa-1="!sidebar"
          >
            <label>{{ $i18n.t('flight_arrival_time') }}</label>
          </v-flex>
          <v-flex
            :xs12="computedMobile"
            :md9="!computedMobile"
            :pa-1="!sidebar"
          >
            <input
              v-model="bookingData.flightArrivalInfo"

              type="text"
              style="color: rgb(128, 128, 128);"
              :class="'full-input ' + (computedMobile ? 'mobile-field' : '')"
            >
          </v-flex>

          <!-- DEPARTURE TIME -->

          <v-flex
            :xs12="computedMobile"
            :md3="!computedMobile"
            pa-1
          >
            <label>{{ $i18n.t('flight_departure_time') }}</label>
          </v-flex>
          <v-flex
            :xs12="computedMobile"
            :md9="!computedMobile"
            pa-1
          >
            <input
              v-model="bookingData.flightDepartureInfo"

              type="text"
              style="color: rgb(128, 128, 128);"
              :class="'full-input ' + (computedMobile ? 'mobile-field' : '')"
            >
          </v-flex>
        </template>

        <!-- BOOKING EXTRAS -->

        <v-flex
          v-if="hasObject"
          :xs12="computedMobile"
          :md3="!computedMobile"
          pa-1
        >
          <label>{{ $i18n.t('booking_extras') }}</label>
        </v-flex>
        <v-flex
          v-if="hasObject"
          :xs12="computedMobile"
          :md9="!computedMobile"
          pa-1
        >
          <booking-form-extras
            :object="object"
          />
        </v-flex>

        <!-- MESSAGE -->

        <v-flex
          :xs12="computedMobile"
          :md3="!computedMobile"
          pa-1
        >
          <label>{{ $i18n.t('sõnum') }}</label>
        </v-flex>
        <v-flex
          :xs12="computedMobile"
          :md9="!computedMobile"
          pa-1
        >
          <textarea
            v-model="bookingData.notes"
            name="message"
            style="color: rgb(128, 128, 128);border:1px solid grey;height:100px !important;"
            class="full-input"
          />
        </v-flex>
      </template>

      <!-- TOTAL PRICE -->

      <v-flex
        v-if="hasObject && !this.computedMobile"
        :xs12="computedMobile"
        :md3="!computedMobile"
        pa-1>
        <label>{{ $i18n.t('total_price') }}</label>
      </v-flex>
      <v-flex
        v-if="hasObject && searchFilters.dateStart && searchFilters.dateEnd && rentalPrice && !loadingObjectInfo"
        :xs12="computedMobile"
        :md9="!computedMobile"
        :pa-1="!sidebar"
        :pt-1="sidebar"
        :pb-3="sidebar"
      >
        <table width="100%">

          <!-- SUMMARY PRICE -->

          <tr v-if="monthlyPrice">

            <!-- MONTH -->

            <td>
              <span style="font-weight: bold; font-size: 16px;color: #219AC8;">
              {{ $i18n.t('monthly_price') }}</span>
              <span>
              <v-icon small class="ml-2"
                      @click="showTotalPriceInfo = true"
              >mdi-information-outline</v-icon>
            </span></td>
            <td style="text-align: right;">
              <span style="font-weight: bold; font-size: 16px;color: #219AC8; white-space: nowrap;">
                {{ monthlyPrice }} €
              </span>
            </td>
          </tr>

          <tr v-if="useMinPeriodPrice && !monthlyPrice">
            <td>
              {{ $i18n.t('rental_price_for_min_period') }}
              ({{ priceObject.minDays }}
              {{ $i18n.t('ööd') }})
            </td>
            <td style="text-align: right;">
              {{ priceObject.bookingMinPeriodPrice }}€
            </td>
          </tr>
          <tr v-else-if="!monthlyPrice">
            <td>
              <div style="float: left">
                {{ $i18n.t('rental_price_for') }} {{ priceObject.bookingDays }} {{ $i18n.t('ööd') }}
                <v-icon small class="ml-2"
                  @click="showDayPrices = true"
                >mdi-information-outline</v-icon>
              </div>
            </td>
            <td style="text-align: right;">
              <span style="cursor:pointer;">{{ priceObject.bookingPrice }} €</span>
            </td>
          </tr>

          <!-- DAY PRICES -->

          <tr
            v-if="showDayPrices"
          >
            <td colspan="2">
              <v-layout
                :class="(sidebar ? 'popup-select-container-sidebar' : 'popup-select-container') + ' elevation-5 '"
                wrap
              >
                <v-layout
                  wrap align-center
                  class="my-0 mt-0 mb-2"
                  style=" padding-bottom: 5px;"
                >
                  <v-flex
                    xs-12
                    text-xs-center
                  >
                    <v-btn
                    fab flat dark small
                    class="form-close"
                    @click="showDayPrices = false"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout wrap style="max-height: 250px; background: white; overflow: auto;">
                  <template
                  v-for="(dayPrice, index) in priceObject.dayPrices"
                  >
                    <v-flex
                      :key="index"
                      xs7
                      style="border-top: 1px solid #DDD;"
                      py-1 px-2
                    >
                      {{ dayPriceTitle(dayPrice) }}<br>
                    </v-flex>
                    <v-flex
                      :key="index + '_p'"
                      xs5
                      style="border-top: 1px solid #DDD;"
                      py-1 px-2
                    >
                      {{ dayPricePrice(dayPrice) }}<br>
                    </v-flex>
                  </template>
                </v-layout>
              </v-layout>
            </td>
          </tr>

          <!-- CLEANING FEE -->

          <tr>
            <td>{{ $i18n.t('cleaning') }}</td>
            <td style="text-align: right;">{{ priceObject.cleaningFee || cleaningFee }} €</td>
          </tr>

          <!-- CSR FEE -->

          <tr>
            <td>{{ $i18n.t('csr_fee') }}</td>
            <td style="text-align: right;">{{ computedCsrFee }} €</td>
          </tr>

          <!-- LATE CHECK-IN FEE -->

          <tr v-if="lateCheckInFee">
            <td>{{ $i18n.t('late_checkin_fee') }}</td>
            <td style="text-align: right;">{{ lateCheckInFee }} €</td>
          </tr>

          <!-- EXTRAS PRICE -->

          <tr>
            <td>{{ $i18n.t('booking_extras') }}</td>
            <td style="text-align: right;">{{ bookingExtrasPrice }} €</td>
          </tr>

          <!-- SUMMARY PRICE -->
          <tr v-if="!monthlyPrice">

            <!-- TOTAL PRICE -->

            <td>
              <span style="font-weight: bold; font-size: 16px;color: #219AC8;">
              {{ $i18n.t('total_price') }}</span>
              <span>
              <v-icon small class="ml-2"
                @click="showTotalPriceInfo = true"
              >mdi-information-outline</v-icon>
            </span></td>
            <td style="text-align: right; white-space: nowrap;">
              <span style="font-weight: bold; font-size: 16px;color: #219AC8;">
                {{ finalPrice }} €
              </span>
            </td>
          </tr>

          <!-- TOTAL PRICE INFO BOX -->

          <tr
            v-if="showTotalPriceInfo"
          >
            <td colspan="2">
              <v-layout
                :class="(sidebar ? 'popup-select-container-sidebar' : 'popup-select-container') + ' elevation-5 '"
                style="margin-top: 10px;"
                wrap
              >
                <v-layout
                  wrap
                  align-center
                  class="my-0 mt-0 mb-2"
                  style=" padding-bottom: 0px; width: 100%;"
                >
                  <v-flex
                    xs-12
                    text-xs-center
                  >
                    <v-btn
                    fab flat dark small
                    class="form-close"
                    @click="showTotalPriceInfo = false"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout wrap style="max-height: 250px; background: white; overflow: auto;">
                  <div style="padding: 0px;background: white;">
                    <v-layout wrap style="max-height: 250px; background: white; overflow: auto;">
                      <v-flex pa-2 xs12>
                        <template
                            v-if="priceObject && priceObject.bookingDays >= 61"
                        >
                          <div v-html="$i18n.t('long_period_rent_info')"/>
                          <br>
                        </template>
                        {{ $i18n.t('price_includes_taxes') }}
                      </v-flex>
                    </v-layout>
                  </div>
                </v-layout>
              </v-layout>
            </td>
          </tr>

          <!-- RESERVATION FEE -->

          <tr>
            <td>
              {{ $i18n.t('reservation_fee') }}
              <v-icon small class="ml-2"
                      @click="showReservationInfo = true"
              >mdi-information-outline</v-icon>
            </td>
            <td style="text-align: right;">{{ reservationFee }} €</td>
          </tr>

          <!-- RESERVATION FEE INFO BOX -->

          <tr
              v-if="showReservationInfo"
          >
            <td colspan="2">
              <v-layout
                  :class="(sidebar ? 'popup-select-container-sidebar' : 'popup-select-container') + ' elevation-5 '"
                  wrap
              >
                <v-layout
                    wrap align-center
                    class="my-0 mt-0 mb-2"
                    style=" padding-bottom: 0px;"
                >
                  <v-flex
                      xs-12
                      text-xs-center
                  >
                    <v-btn
                        fab flat dark small
                        class="form-close"
                        @click="showReservationInfo = false"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout wrap style="max-height: 250px; background: white; overflow: auto;">
                  <div style="padding: 0px;background: white;">
                    <v-layout wrap style="max-height: 250px; background: white; overflow: auto;">
                      <v-flex pa-2 xs12>
                        {{ $i18n.t('reservation_fee_info') }}
                      </v-flex>
                    </v-layout>
                  </div>
                </v-layout>
              </v-layout>
            </td>
          </tr>

        </table>

      </v-flex>
      <v-flex v-else-if="hasObject && loadingObjectInfo"
        :xs12="computedMobile"
        :md9="!computedMobile"
        :pa-1="!sidebar"
        :pa-3="sidebar"
        justify-center
        text-xs-center
        class="center text-center justify-center"
      >
        <v-progress-circular
          indeterminate
          color="amber"
          size="25"
          width="2"
        />
      </v-flex>
      <v-flex
        v-else-if="hasObject && (!searchFilters.dateStart || !searchFilters.dateEnd)"
        :xs12="computedMobile"
        :md9="!computedMobile"
        :pa-1="!sidebar"
        :py-3="sidebar"
      >
        {{ $i18n.t('please_select_dates') }}
      </v-flex>
      <v-flex v-else-if="hasObject"
        :xs12="computedMobile"
        :md9="!computedMobile"
        :pa-1="!sidebar"
        :py-3="sidebar"
      >
        <span style="color: red;">
          {{ $i18n.t('dates_not_available') }}
        </span>
      </v-flex>

      <!-- TERMS CONFIRM -->

      <v-flex
        v-if="hasObject && !sidebar"
        :xs12="computedMobile"
        :md3="!computedMobile"
        pa-1
      >
        <label>&nbsp;</label>
      </v-flex>
      <v-flex
        v-if="hasObject && !sidebar"
        :xs12="computedMobile"
        :md9="!computedMobile"
        pa-1
      >
        <input
          v-model="bookingData.confirmed"
          type="checkbox"
          style="color: rgb(128, 128, 128);"
        >
        &nbsp;<a target="_blank" :href="conditionsLink">{{ $i18n.t('terms_and_conditions_link') }}</a>
      </v-flex>


      <!-- SEND BUTTON -->

      <v-flex
        v-if="!sidebar"
        :xs12="computedMobile"
        :md3="!computedMobile"
        pa-1
      >
      </v-flex>
      <v-flex
        :xs12="computedMobile"
        :md9="!computedMobile"
        :pa-1="!sidebar"
      >
        <input
          type="button"
          id="send_feedback"
          name="send"
          :class="(!canBookNow ? 'disabled-button ' : '') +
          (computedMobile ? 'mobile-button' : ' booking-deskop-button ')"
          :value="hasObject ? $i18n.t('book_button') : $i18n.t('saada') "
          style="width: 100%;"
          :value_x="'Send booking for ' + (priceObject.bookingDays ? priceObject.bookingDays : '') +
            ' nights with ' + (priceObject.bookingPrice ? priceObject.bookingPrice + '€' : '') "
          @click="clickHandler"
        >
      </v-flex>

      <!-- NO CHARGES TEXT -->

      <v-flex
        v-if="hasObject && !computedMobile"
        md3
        pa-1
      >
      </v-flex>
      <v-flex
        v-if="hasObject"
        :xs12="computedMobile"
        :md9="!computedMobile"
        text-xs-center pt-2 pb-1>
        <b>{{ $i18n.t('no_charges_yet') }}</b>
      </v-flex>
      <v-flex
        v-if="hasObject && sidebar"
        :xs12="computedMobile"
        :md9="!computedMobile"
        pa-1
      >
        <i v-if="showValidationError">
          {{ $i18n.t('fill_all_fields') }}
        </i>
      </v-flex>

      <!-- BACK BUTTON -->

      <v-flex
        v-if="hasObject && !computedMobile"
        xs-12
        mt-3
        class="text-xs-right"
      >
        <input
          class="button-silver"
          style="margin-left: 10px;"
          type="button"
          :value="'&lt; ' + $t('tagasi')"
          @click="goBack"
        >
      </v-flex>
    </template>
    <template v-else>
      <v-flex xs12>
        <h1>{{ $t('booking_sent_title') }}</h1>
        <div v-html="$t('booking_sent_message')" />
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
import MyLoader from './../components/_MyLoader'
import BookingFormExtras from './../components/BookingFormExtras'
import moment from 'moment'
import sharedMethods from './../methods/sharedMethods'
import ObjectListInfo from './ObjectListInfo'
import CalendarDatePicker from './CalendarDatePicker'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
import sharedObjectComputed from "@/views/sharedObjectComputed"
const countryCodes = require('country-codes-list')

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

const countryCallingCodesByLocale = {
  et: '+372',
  fi: '+358',
  ru: '+7',
  es: '+34',
  en: '+44',
}

export default {
  name: 'BookingForm',

  components: {
    CalendarDatePicker,
    BookingFormExtras,
    ObjectListInfo,
    MyLoader
  },

  data: () => {
    return {
      personTypes: ['adults', 'kids', 'infants'],
      personSelectOpened: false,
      showValidationError: false,
      bookingSent: false,
      defaultCsrFee: 45,
      cleaningFee: 65,
      showDayPrices: false,
      showReservationInfo: false,
      showTotalPriceInfo: false,
      x: 0,
      y: 0,
      selectedCountryCallingCode: null,
    }
  },

  watch: {
    bookObjectId () {
      this.limitMaxPeople()
      this.resetExtras()
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedObjectComputed,

    countryCallingCodes () {
      return countryCodes.customList('countryCallingCode', '{countryNameLocal} (+{countryCallingCode})') // countryNameEn
    },

    monthlyPrice () {
      if (this.priceObject && this.priceObject.bookingDays >= 61) {
        return Math.round(this.rentalPrice / this.priceObject.bookingDays * 30)
      }
      return null
    },

    reservationFee () {
      let reservationFee = Math.round(this.rentalPrice * 0.3)
      if (this.monthlyPrice && reservationFee > this.monthlyPrice) {
        return this.monthlyPrice
      }
      reservationFee = Math.round(reservationFee / 10) * 10
      return reservationFee
    },

    computedCsrFee () {
      if (this.priceObject && this.priceObject.longTermRentCsrFee > 0) {
        return this.priceObject.longTermRentCsrFee
      }
      if (this.priceObject && this.priceObject.csrFee > 0) {
        return this.priceObject.csrFee
      }
      return this.defaultCsrFee
    },

    hasObject () {
      return this.object && this.object.id
    },

    calendarLeftPosition () {
      return this.sidebar
        ? '-20px'
        : '0px'
    },

    calendarMobilePadding () {
      return 13
    },

    selectedPersonsText () {
      let selectedText = this.personTypes.map((personType, index) => {
        if (this.bookingData[personType]) {
          let count = this.bookingData[personType]
          if (count > 0) {
            let nameField = count > 1 ? personType : personType.substring(0, personType.length - 1)
            return this.bookingData[personType] + ' ' + this.$i18n.t(nameField)
          }
          return null
        }
        return 0
      })
      .filter(name => name)
      .join(', ')

      return selectedText || this.$i18n.t('select')
    },

    bookingExtrasPrice () {
      return this.bookingExtras.map((bookingExtra, index) => {
        if (this.bookingExtrasSelected && this.bookingExtrasSelected[index]) {
          return bookingExtra.price * this.bookingExtrasSelected[index]
        }
        return 0
      })
      .reduce((x, y) => x + y)
    },

    conditionsLink () {
      return this.pagesById && this.pagesById['5e00d1adbd2fe35f079f24b5']['seoName_' + this.lang] + '_' + this.lang + '_page.html?showArticleOnly=1'
    },

    bookObjectId () {
      return this.object && this.object._id || null
    },

    computedMobile () {
      return this.mobile || this.sidebar || !this.$vuetify.breakpoint.mdAndUp
    },

    /*loadingObjectInfo () {

      return !this.object || (this.object && !this.object._id)
    },*/

    finalPrice () {
      const cleaningFee = this.object.cleaningFee || this.cleaningFee
      return parseInt(
        (cleaningFee +
          this.computedCsrFee +
          this.rentalPrice +
          this.lateCheckInFee +
          this.bookingExtrasPrice
        )
       * 100) / 100
    },

    lateCheckInFee () {
      let fee = null
      if (this.bookingData.checkInTime) {

        const p = this.searchFilters.dateStart.split('.')
        const momentFriendly = p[2] + '-' + p[1] + '-' + p[0]
        const dayOfWeek = moment(momentFriendly).isoWeekday()

        let h = parseInt(this.bookingData.checkInTime.substr(0, 2))
        if (h < 10 && h >= 1) {
          fee = this.$i18n.t('very_late_checkin_price') ? parseInt(this.$i18n.t('very_late_checkin_price')) : 0
        } else if (h >= 20 || h < 1) {
          fee = this.$i18n.t('late_checkin_price') ? parseInt(this.$i18n.t('late_checkin_price')) : 0
        }
        if (dayOfWeek === 7 && (h >= 18 || h <= 9)) {
          fee = this.$i18n.t('sunday_late_checkin_price') ? parseInt(this.$i18n.t('sunday_late_checkin_price')) : 0
        }
      }
      return fee
    },

    bookingEndLeftForMobile () {
      let left = window.innerWidth < 400
        ? ((-1)*((window.innerWidth / 2) - 60)) + 'px'
        : ''
      return left
    },

    confirmed () {
      return this.bookingData.confirmed
    },

    canBookNow () {
      const objectAvailable = this.searchFilters.dateStart &&
        this.searchFilters.dateEnd &&
        this.bookNowAvailable &&
        this.bookingData.confirmed
      return this.sidebar ||
        ((objectAvailable || !this.hasObject) &&
        this.bookingData.customerName &&
        this.bookingData.customerEmail &&
        this.bookingData.customerPhone &&
        this.bookingData.adults > 0)
    },

    checkInTimes () {
      let momentFriendly = '';
      let nextDay = '';
      let options = [];
      if (this.searchFilters.dateStart) {
        let p = this.searchFilters.dateStart.split('.')
        momentFriendly = p[2] + '-' + p[1] + '-' + p[0]
        nextDay = moment(momentFriendly).add(1, 'day').format('DD.MM')
      }
      [...Array(14)].forEach((c, i) => {
        let isNextDay = false
        let s = i + 16
        if (s >= 24) {
          s = s - 24
          isNextDay = true
        }
        const h = s < 10 ? '0' + s : s
        options.push(h + ':00' + (isNextDay && nextDay ? ' / ' + nextDay : ''))
      })
      return options
    },

    checkOutTimes () {
      return [...Array(24)].map((c, i) => {
        const h = i < 10 ? '0' + i : i
        return h + ':00'
      })
    }
  },

  props: {
    object: {
      type: Object,
      default: () => {
        return {}
      }
    },

    sidebar: {
      type: Boolean,
      default: false
    }
  },

  created () {
    this.selectedCountryCallingCode = countryCallingCodesByLocale[this.lang]
    this.bookingData.confirmed = false
    this.bookingSent = false

    this.limitMaxPeople()
    // this.resetExtras()
  },

  methods: {
    ...sharedMethods,

    dateStartFocus (e) {
      e.srcElement.blur()
      this.showBookingPickerFor = 'dateStart'
    },

    dateEndFocus (e) {
      e.srcElement.blur()
      this.showBookingPickerFor = 'dateEnd'
    },

    limitMaxPeople () {
      this.$store.dispatch('limitMaxPeople')
    },

    resetExtras () {
      this.bookingExtrasSelected = {}
    },

    addPerson (type) {
      const currentTotal = this.bookingData.adults + this.bookingData.kids
      if (!this.hasObject || this.object.maxPeople > currentTotal || type === 'infants') {
        this.bookingData[type]++
      }
    },

    removePerson (type) {
      this.bookingData[type]--
      if (this.bookingData[type] < 0) { this.bookingData[type] = 0 }
      if (this.bookingData[type] === 0  && type === 'adults') {
        this.bookingData[type] = 1
      }
    },

    goBack () {
      window.history.back()
    },

    clickHandler () {
      if (!this.canBookNow) { return }
      if (this.sidebar) {
        // this.showBookNowForm = true
        this.$router.push({ path: this.objectBookingLink(this.object) })
      } else {
        this.sendBooking()
        window.scrollTo(0, 0)
      }
    },

    dayPriceTitle (price) {
      return moment(price.day).format('DD.MM.YYYY')
    },

    dayPricePrice (price) {
      return price.price + ' €'
    },

    // handleShowDayPricesClick (e) {
    //   e.preventDefault()
    //     this.showDayPrices = false
    //     this.x = e.clientX
    //     this.y = e.clientY
    //     this.$nextTick(() => {
    //       this.showDayPrices = true
    //     })
    // },

    sendBooking () {
      this.bookingData.customerPhone = this.selectedCountryCallingCode + ' ' + this.bookingData.customerPhone
      if (!this.hasObject) {
        this.bookingSent = true
        this.$store.dispatch('sendContact', {
          contact: this.bookingData,
          translations: {
            name: this.$i18n.t('nimi'),
            email: this.$i18n.t('e-mail'),
            phone: this.$i18n.t('telefon'),
            guests: this.$i18n.t('inimeste_arv'),
            checkinDate: this.$i18n.t('saabumise_kuupäev'),
            checkoutDate: this.$i18n.t('lahkumise_kuupäev'),
            adults: this.$i18n.t('adults_count'),
            kids: this.$i18n.t('kids_count'),
            infants: this.$i18n.t('infants_count'),
            message: this.$i18n.t('sõnum'),
          }
        }).then()
        return
      }
      this.showValidationError = false
      if (!this.canBookNow) {
        this.showValidationError = true
        return
      }
      this.bookingSent = true
      this.$store.dispatch('sendBooking', {
        booking: {
          ...this.bookingData,
          lateCheckInFee: this.lateCheckInFee,
          object: this.priceObject._id,
          priceCalculatedConfirmation: this.priceObject.bookingPrice,
          objectInfo: this.priceObject
        },
        translations: {
          name: this.$i18n.t('nimi'),
          email: this.$i18n.t('e-mail'),
          phone: this.$i18n.t('telefon'),
          guests: this.$i18n.t('inimeste_arv'),
          checkinDate: this.$i18n.t('saabumise_kuupäev'),
          checkoutDate: this.$i18n.t('lahkumise_kuupäev'),
          adults: this.$i18n.t('adults_count'),
          kids: this.$i18n.t('kids_count'),
          infants: this.$i18n.t('infants_count'),
          message: this.$i18n.t('sõnum'),
          csr_fee: this.$i18n.t('csr_fee'),
          cleaning:this.$i18n.t('cleaning'),
          rental_price: this.$i18n.t('rental_price'),
          late_checkin_fee: this.$i18n.t('late_checkin_fee'),
          reservation_fee: this.$i18n.t('reservation_fee'),
          booking_extras: this.$i18n.t('booking_extras'),
          total_price: this.$i18n.t('total_price'),
          monthly_price: this.$i18n.t('monthly_price'),
          booking: this.$i18n.t('broneering'),
          night: this.$i18n.t('öö'),
          nights: this.$i18n.t('ööd')
        }
      }).then(() => {

      })
    }
  }
}
</script>

<style>
.full-input {
  width: 100%;
}
input[type="text"].filter-calendar, input[type="text"].contact_calendar_icon {
    background: url(../../public/img/calendar-icon.png) no-repeat left top;
    background-position: 2px 1px;
    padding-left: 29px;
    margin: 0;
    background-color: white;
}
textarea.contact_input {
    height: 150px;
    color: rgb(128, 128, 128);
}
ul.contact_form li {
    list-style-type: none;
    margin-bottom: 5px;
}
.booking-deskop-button {
  height: 30px;
  font-size: 14px !important;
}
.costa-close .v-btn--floating.v-btn--small {
  width: 24px;
  height: 24px;
}
.popup-select-container {
  margin: 0 0 10px 0;
  padding: 20px;
}
.popup-select-container-sidebar {
  margin: 10px 0 10px 0;
  padding: 13px;
}
@media screen and (max-width: 700px) {
  .popup-select-container {
    padding: 13px;
  }
}
.sidebar-plus {
  margin: 5px -5px 5px 5px !important;
}
.sidebar-minus {
  margin: 5px 7px 5px -7px !important;
}
</style>
